import smile from "assets/images/banners/eyeInternal/smilepro.jpg";
import contoura from "assets/images/banners/eyeInternal/specremoval.jpg";
import catract from "assets/images/banners/eyeInternal/catract.jpg";
import gulcoma from "assets/images/banners/eyeInternal/glaucoma.jpg";
import cornea from "assets/images/banners/eyeInternal/cornea&karetoconous.jpg";
import pedia from "assets/images/banners/eyeInternal/pediatricopthalmology.jpg";
import retina from "assets/images/banners/eyeInternal/retina.jpg";
import oculo from "assets/images/banners/eyeInternal/oculoplastyandcosmaticenhancement.jpg";
import contace from "assets/images/banners/eyeInternal/contactlenses.jpg";
import neuro from "assets/images/banners/eyeInternal/neuroopthamology.jpg";
import lowvision from "assets/images/banners/eyeInternal/lowvisionsyndrome.jpg";

import cataractI from "assets/images/banners/eyeInternalBanner/cataract.png";
import contactLensesI from "assets/images/banners/eyeInternalBanner/contactLens.png";
import contoruaI from "assets/images/banners/eyeInternalBanner/contouraVision.png";
import corneaI from "assets/images/banners/eyeInternalBanner/cornea.png";
import glaucomaI from "assets/images/banners/eyeInternalBanner/glaucoma.png";
import lowvisionI from "assets/images/banners/eyeInternalBanner/lowVision.png";
import neuroI from "assets/images/banners/eyeInternalBanner/neuroOpth.png";
import oculoI from "assets/images/banners/eyeInternalBanner/oculo.png";
import pediaI from "assets/images/banners/eyeInternalBanner/pedia.png";
import retinaI from "assets/images/banners/eyeInternalBanner/retina.png";
import smileProI from "assets/images/banners/eyeInternalBanner/smilePro.png";

export const internalData = [
  {
    id: "smileProSurgery",
    label: "SMILE Pro Eye Surgery in Chennai — Advanced Laser Vision Correction at Amrit Hospitals",
    img: smile,
   alt: "Patient receiving SMILE Pro eye surgery using advanced laser technology at Amrit Hospitals Chennai",
    banner: smileProI,
    title: "SMILE Pro Eye Surgery in Chennai — Advanced Laser Vision Correction at Amrit Hospitals",
    description: "Get SMILE Pro eye surgery in Chennai — robotic eye power correction surgery. Blade-free procedure. Ophthalmologists at Amrit Hospitals. Book today!",
    keyword: "",
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What is SMILE Pro Eye Surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "SMILE Pro Eye Surgery is a minimally invasive laser vision correction procedure that uses advanced femtosecond laser technology to correct refractive errors such as myopia and astigmatism. It is a flapless procedure designed to provide clear vision with faster recovery and minimal discomfort.",
          },
        },
        {
          "@type": "Question",
          name: "Why choose Amrit Hospitals for SMILE Pro Eye Surgery in Chennai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Amrit Hospitals offers advanced SMILE Pro technology, experienced ophthalmologists, comprehensive eye evaluations, and personalized treatment plans to help patients achieve safe and effective vision correction.",
          },
        },
        {
          "@type": "Question",
          name: "Who is eligible for SMILE Pro Eye Surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Adults with stable vision, healthy corneas, and suitable refractive errors may be eligible for SMILE Pro Eye Surgery. A detailed eye examination is required to determine candidacy.",
          },
        },
        {
          "@type": "Question",
          name: "Is SMILE Pro Eye Surgery safe?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. SMILE Pro Eye Surgery is considered a safe and effective laser vision correction procedure when performed by qualified eye specialists following a comprehensive pre-operative evaluation.",
          },
        },
        {
          "@type": "Question",
          name: "How is SMILE Pro Eye Surgery performed?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "SMILE Pro surgery uses a femtosecond laser to create a small lenticule within the cornea. The lenticule is removed through a tiny keyhole incision, reshaping the cornea and correcting vision without creating a corneal flap.",
          },
        },
        {
          "@type": "Question",
          name: "What are the benefits of SMILE Pro Eye Surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Benefits include a flapless procedure, minimal discomfort, faster recovery, reduced dry eye symptoms, quick return to daily activities, and long-term vision correction.",
          },
        },
        {
          "@type": "Question",
          name: "How long does recovery take after SMILE Pro surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most patients experience significant visual improvement within 24 to 48 hours and can resume normal daily activities shortly after the procedure, depending on individual healing.",
          },
        },
        {
          "@type": "Question",
          name: "Can SMILE Pro surgery eliminate the need for glasses or contact lenses?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "SMILE Pro Eye Surgery is designed to reduce or eliminate dependence on glasses and contact lenses by correcting refractive errors and improving visual clarity.",
          },
        },
        {
          "@type": "Question",
          name: "What post-operative care is provided after SMILE Pro Eye Surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Patients receive follow-up appointments, vision monitoring, medication guidance, and recovery instructions to support healing and achieve the best possible visual outcomes.",
          },
        },
        {
          "@type": "Question",
          name: "How can I book a consultation for SMILE Pro Eye Surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can schedule a consultation through our online appointment system, contact our ophthalmology department directly, or speak with our patient care team for assistance.",
          },
        },
      ],
    },
    data: [
      {
        header: "What is SMILE Pro Eye Surgery? — A Laser Eye Power Correction Surgery Explained",
        content:
          "SMILE Pro Eye Surgery is the world's first robotic flapless and minimally invasive laser vision correction surgery. It uses advanced laser technology to reshape the cornea with unparalleled precision, restoring perfect vision in just 9 seconds. As the leading eye power correction surgery available at Amrit Hospitals — the best eye hospital for SMILE Pro in Chennai — this procedure offers patients permanent freedom from glasses with no blades, no flap, and minimal discomfort.",
        points: null,
      },
      {
        header: "Is SMILE Pro Eye Surgery Right for You? — Candidacy Guide",
        content:
          "Ideal for those looking to eliminate the need for glasses or contact lenses, SMILE Pro eye surgery offers a quick, virtually pain-free solution with a rapid recovery time.Minimal Discomfort: Suitable for those who want a virtually pain-free eye power correction procedure.Fast Recovery: Ideal if you want to resume day-to-day activities quickly, usually within 24 hours of SMILE Pro surgery.Freedom from Glasses: Great for anyone looking to enjoy a life free from glasses or contact lenses through this advanced laser vision correction surgery.",
        points: [
          "Minimal Discomfort: Suitable for those who want a virtually pain-free procedure.",
          "Fast Recovery: Ideal if you want to resume day-to-day activities quickly, usually within 24 hours.",
          "Freedom from Glasses: Great for anyone looking to enjoy a life free from glasses or contact lenses.",
        ],
      },
      {
        header: "How is SMILE Pro Eye Surgery Performed? — Step-by-Step Procedure",
        content:
          "The SMILE Pro eye surgery involves making a keyhole incision for lenticule extraction. The precision laser vision correction surgery technology reshapes the cornea in just 9 seconds — making it the world's fastest eye power correction surgery available today.Minimally Invasive: A tiny keyhole incision of just 3 mm — no flap creation unlike conventional laser eye surgery.High Precision: Advanced robotic laser technology reshapes the cornea with sub-micron accuracy for consistently clear results.",
        points: [
          "Minimally Invasive: A tiny keyhole incision of just 3 mm.",
          "High Precision: Advanced laser technology reshapes the cornea.",
        ],
      },
    ],
faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1.Why Choose Amrit Hospital for SMILE Pro Surgery?",
        content:
          " Amrit Hospital is the best eye hospital for SMILE Pro surgery in Chennai, offering advanced SMILE Pro vision correction supported by experienced eye surgeons and modern laser technology, ensuring precise treatment and patient comfort",
      },
      {
        label: "2. What Is SMILE Pro Surgery Offered at Amrit Hospital?",
        content:
          "SMILE Pro is a minimally invasive laser vision correction surgery and the most advanced form of eye power correction surgery designed to improve visual clarity with enhanced accuracy and faster recovery.",
      },
      {
        label: "3.Is SMILE Pro Surgery Safe at Amrit Hospital?",
        content:
          "Patient safety is ensured through advanced laser systems, detailed eye evaluations, and strict surgical protocols followed by trained ophthalmic specialists. Our SMILE Pro eye surgery carries a 98%+ patient satisfaction rate.",
      },
      {
        label: "4.Who Can Benefit From SMILE Pro Surgery?",
        content:
          "Patients seeking a permanent eye power correction surgery and freedom from glasses or contact lenses may benefit after a comprehensive eye assessment conducted by our ophthalmology team.",
      },
      {
        label: "5. What Technology Is Used for SMILE Pro Surgery?",
        content:
          "Amrit Hospital utilizes advanced laser platforms and diagnostic tools to support precise SMILE Pro eye surgery correction and consistent outcomes — the same technology used in the world's best eye hospitals.",
      },
      {
        label: "6.What Kind of Post-Procedure Care Is Provided?",
        content:
          "We provide structured post-surgery follow-up, vision monitoring, and guidance to support smooth healing and visual improvement after your laser vision correction surgery at Amrit Hospitals.",
      },
      {
        label: "7. How Can I Schedule a Consultation for SMILE Pro Surgery?",
        content:
          "Appointments for SMILE Pro eye surgery can be booked through our online system or by contacting the hospital directly for consultation with our eye specialists.",
      },
    ],
  },

  },
  {
    id: "contouraVision",
    label: "Contoura Vision - Specs Removal",
    img: contoura,
    banner: contoruaI,
     title: "Contoura Vision Correction in Chennai – Latest LASIK Technology",
    description: "Get advanced Contoura Vision in Chennai with LASIK eye surgery at Amrit Hospitals. Safe laser vision correction by expert eye specialists. Book today.",
    keyword: "",
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Why choose Amrith Hospitals for Contoura Vision in Chennai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Amrith Hospitals offers advanced Contoura Vision treatment in Chennai using topography-guided LASIK technology, personalized corneal mapping, and experienced refractive surgeons. Our comprehensive eye evaluations and modern laser systems help deliver safe and precise vision correction.",
          },
        },
        {
          "@type": "Question",
          name: "What is Contoura Vision treatment?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Contoura Vision is an advanced FDA-approved laser eye surgery that uses topography-guided LASIK technology to create a customized treatment plan based on the unique shape of your cornea. It helps improve vision quality, reduce glare, and provide more accurate vision correction than conventional LASIK.",
          },
        },
        {
          "@type": "Question",
          name: "Who is eligible for Contoura Vision surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Adults above 18 years of age with stable eye power, healthy corneas, adequate corneal thickness, and no active eye infections may be eligible for Contoura Vision treatment. A detailed eye examination is required to confirm suitability.",
          },
        },
        {
          "@type": "Question",
          name: "How does Contoura Vision LASIK eye surgery work?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Contoura Vision begins with advanced corneal topography mapping that captures thousands of elevation points on the eye surface. This data is used to create a personalized laser treatment plan that reshapes the cornea and corrects vision irregularities with high precision.",
          },
        },
        {
          "@type": "Question",
          name: "Is Contoura Vision surgery safe?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Contoura Vision is an FDA-approved laser vision correction procedure and is considered safe when performed by experienced ophthalmologists using advanced diagnostic and laser technology.",
          },
        },
        {
          "@type": "Question",
          name: "What are the benefits of Contoura Vision treatment?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Benefits of Contoura Vision include sharper visual clarity, personalized laser correction, reduced glare and halos, improved night vision, enhanced contrast sensitivity, minimal discomfort, and faster recovery compared to traditional LASIK procedures.",
          },
        },
        {
          "@type": "Question",
          name: "How long does recovery take after Contoura Vision surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most patients notice significant visual improvement within 24 to 48 hours after Contoura Vision treatment and can resume normal activities within a few days. Complete vision stabilization may take several weeks.",
          },
        },
        {
          "@type": "Question",
          name: "Can Contoura Vision permanently remove glasses or contact lenses?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Contoura Vision is designed to reduce or eliminate dependence on glasses and contact lenses by correcting refractive errors such as myopia, hyperopia, and astigmatism. Individual results may vary based on eye health and prescription.",
          },
        },
        {
          "@type": "Question",
          name: "Who performs Contoura Vision treatment at Amrith Hospitals?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Contoura Vision procedures at Amrith Hospitals are performed by experienced ophthalmologists and refractive eye surgeons using advanced diagnostic systems and topography-guided LASIK technology.",
          },
        },
        {
          "@type": "Question",
          name: "How can I book a consultation for Contoura Vision in Chennai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can schedule a Contoura Vision consultation through our online appointment system, contact our ophthalmology department directly, or speak with our patient care team for assistance with booking.",
          },
        },
      ],
    },
    data: [
      {
        header: "What is Contoura Vision Treatment?",
        content:
          "Contoura Vision is an advanced LASIK procedure that uses computer-guided topographic mapping to correct vision by addressing the microscopic contours of the cornea, providing superior visual acuity and refractive outcomes.",
        points: null,
      },
      {
        header: "Who is Eligible for Contoura Vision in Chennai?",
        content:
          "Perfect for individuals looking to achieve better visual acuity than traditional LASIK, Contoura Vision is recommended for those with irregular corneal curvature and vision issues not adequately addressed by standard procedures.",
        points: [
          "Personalized Treatment: Ideal for those with unique corneal irregularities.",
          "Superior Visual Acuity: Suitable for anyone wanting better results than traditional LASIK.",
          "Customized Procedure: Perfect for individuals needing a highly tailored treatment plan.",
        ],
      },
      {
        header: "How Does Contoura Vision LASIK Eye Surgery Work?",
        content:
          "Contoura Vision uses a specially designed laser programmed with data from a topographic map of your cornea.",
        points: [
          "Topographic Mapping: Maps at least 22,000 points on your cornea.",
          "Custom Laser Application: Uses a laser designed specifically for your corneal contours.",
          "Precise Corrections: Treats vision irregularities with remarkable precision.",
        ],
      },
      {
        header: "HOW DOES CONTOURA VISION LASIK SURGERY WORK?",
         points: [
          "Eye Laser Surgery",
          "Contoura Vision Treatment",
        ],
        content:
          "The Contoura Vision procedure begins with advanced corneal topography mapping that captures over 22,000 elevation points on the eye surface. This detailed map helps surgeons identify even microscopic irregularities affecting vision quality.",
        points1: [
          "A detailed corneal scan is performed.",
          "A customized treatment plan is generated.",
          "Advanced laser technology reshapes the cornea.",
          "Vision irregularities are corrected with precision.",
        ],
          content1:
          "The entire treatment generally takes only a few minutes per eye, and most patients notice visual improvement within 24–48 hours.",
      },
      {
        header: " BENEFITS OF CONTOURA VISION TREATMENT",
         points: [
          "Best Contoura Vision Surgery",
          "Eye Laser Surgery",
        ],
        content:
          "Benefits of Contoura Vision treatment include:",
        points1: [
          "Sharper visual clarity compared to standard LASIK",
          "Personalized treatment based on unique corneal mapping",
          "Reduced glare and halos during night driving",
          "Improved contrast sensitivity",
          "Minimal discomfort and faster recovery",
          "High precision laser correction",
          "Long-lasting vision improvement",
        ],
          content1:
          "Many patients choose Contoura Vision because it offers a more customized and accurate approach to laser eye surgery.",
      },
      {
        header: "WHY CHOOSE AMRIT HOSPITALS?",
         points: [
          "Best Eye Hospital for Contoura Vision",
          "Best LASIK Surgeon in Chennai",
        ],
        content:
          "Amrith Hospitals is recognized for advanced ophthalmology and refractive eye care services in Chennai. Our hospital combines experienced eye specialists with modern diagnostic and laser technologies to deliver safe and effective Contoura Vision treatment. Why patients choose us:",
        points1: [
          "Advanced topography-guided LASIK systems",
          "Experienced ophthalmologists and refractive surgeons",
          "Comprehensive eye evaluation and diagnostics",
          "Personalized treatment planning",
          "Structured post-operative care",
          "Modern infrastructure and patient-focused care",
          "High standards of safety and precision",
        ],
          content1:
          "Many patients choose Contoura Vision because it offers a more customized and accurate approach to laser eye surgery.",
      },
  
    ],
    faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1. Why Is Amrit Hospital Preferred for Contoura Vision Treatment?",
        content:
          " Amrit Hospital delivers customized vision correction using advanced Contoura Vision technology supported by skilled ophthalmologists.",
      },
      {
        label: "2. What Is Contoura Vision Treatment?",
        content:
          " Contoura Vision treatment is an advanced FDA-approved laser eye surgery procedure that uses topography-guided LASIK technology to create a personalized treatment plan for each eye. The procedure analyzes the corneal surface in extreme detail and uses customized laser correction to improve both vision quality and refractive accuracy.Unlike conventional LASIK surgery, Contoura Vision focuses on correcting microscopic imperfections on the corneal surface, helping patients achieve sharper night vision, improved contrast sensitivity, and reduced glare.",
      },
      {
        label: "3. Is Contoura Vision Safe at Amrit Hospital?",
        content:
          " Yes, the procedure is performed using advanced laser systems with strict safety standards and expert clinical supervision.",
      },
      {
        label: "4. How Does Amrit Hospital Ensure Accuracy in Contoura Vision?",
        content:
          " We use high-precision diagnostic equipment to customize treatment for each patient’s eye structure.",
      },
      {
        label: "5. What Care Is Provided After Contoura Vision Treatment?",
        content:
          " Patients receive structured follow-up care and vision monitoring to support recovery and long-term results.",
      },
      {
        label: "6. Who Can Consider Contoura Vision Treatment?",
        content:
          "Eligibility is determined after a comprehensive eye evaluation conducted by our ophthalmology team.",
      },
      {
        label: "7. How Do I Book an Appointment for Contoura Vision?",
        content:
          " Consultations can be scheduled via phone or through our online appointment system.",
      },

    ],
  },
  },
  {
    id: "cataract",
    label: "Cataract Specialist in Chennai – Restore Your Vision at Amrit Hospitals",
    img: catract,
    alt:"Ophthalmologist performing eye screening on elderly patient using vision testing machine",
    banner: cataractI,
     title: "Advanced Cataract Specialist in Chennai | Amrit Hospitals",
    description: "Restore your vision with advanced cataract surgery in Chennai at Amrit Hospitals. Get treated by expert ophthalmologists. Painless & effective.",
    keyword: "",
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Why Choose Amrit Hospitals for Cataract Treatment?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our ophthalmology team combines decades of surgical experience with advanced technology to deliver safe and precise cataract care. Every patient receives a personalised treatment plan focused on restoring clear, comfortable vision.",
          },
        },
        {
          "@type": "Question",
          name: "What Cataract Services Are Available at Amrit Hospitals?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We offer a full spectrum of cataract services including diagnosis, pre-operative evaluation, phacoemulsification surgery, robotic cataract surgery, premium intraocular lens implantation, and structured post-operative follow-up care.",
          },
        },
        {
          "@type": "Question",
          name: "Is Cataract Surgery Safe?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Cataract surgery is one of the safest and most commonly performed eye procedures worldwide. Our surgeons follow strict clinical protocols and conduct comprehensive eye assessments before surgery to ensure the best possible outcomes.",
          },
        },
        {
          "@type": "Question",
          name: "What Technology Is Used for Cataract Surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "We use advanced phacoemulsification technology, optical biometry, micro-incision techniques, and premium intraocular lenses to provide accurate vision correction and faster recovery after cataract surgery.",
          },
        },
        {
          "@type": "Question",
          name: "What Is Robotic Cataract Surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Robotic cataract surgery, also known as femtosecond laser-assisted cataract surgery, uses computer-guided laser technology to perform key surgical steps with exceptional precision. This blade-free approach can improve accuracy and visual outcomes.",
          },
        },
        {
          "@type": "Question",
          name: "Is Robotic Cataract Surgery Available at Amrit Hospitals?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Amrit Hospitals offers advanced femtosecond laser-assisted cataract surgery performed by experienced ophthalmologists using real-time imaging and laser-guided technology.",
          },
        },
        {
          "@type": "Question",
          name: "Is Robotic Cataract Surgery Safe for Elderly Patients?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Robotic cataract surgery is often suitable for elderly patients, especially those with dense cataracts. The laser-assisted approach may reduce surgical energy and improve precision, supporting a smoother recovery.",
          },
        },
        {
          "@type": "Question",
          name: "How Long Does Recovery Take After Cataract Surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Most patients notice improved vision within 24 to 48 hours after cataract surgery. Complete healing and visual stabilisation typically occur within four to six weeks, depending on individual eye health.",
          },
        },
        {
          "@type": "Question",
          name: "Does Amrit Hospitals Treat Cataracts in Elderly Patients?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes. Age-related cataracts are among the most common conditions we treat. Elderly patients receive personalised care, comprehensive pre-operative assessments, and dedicated post-operative support.",
          },
        },
        {
          "@type": "Question",
          name: "How Can I Book an Appointment for Cataract Treatment?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can book an appointment online, contact our hospital directly, or use the enquiry form on our website. Our eye care team will help schedule a consultation with a cataract specialist.",
          },
        },
      ],
    },
    data: [
      {
        header: "What is Cataract Surgery?",
        content:
          "A cataract develops when the natural lens of the eye becomes cloudy, causing progressive blurring of vision. Cataract surgery is a short, safe outpatient procedure in which the clouded lens is removed and replaced with a clear artificial lens called an intraocular lens (IOL) - restoring sharp, natural vision.The procedure is performed under local anaesthesia, typically takes 15–20 minutes per eye, and requires no stitches. Most patients notice a significant improvement in clarity within 24–48 hours.",
        points: null,
      },
      {
        header: "Is Cataract Surgery Right for You?",
        content:
          " Surgery is generally recommended when cataracts begin to affect your daily activities. You may be a candidate if you experience",
        points: [
          "Blurry, hazy, or dimmed vision that glasses no longer fully correct",
          "  Difficulty reading, driving, or watching television clearly",
          "Increased sensitivity to glare — especially at night or in bright light",
          "Frequent changes to your spectacle prescription",
          "Fading or yellowing of colours",
        ],
          content1:
          "A pre-operative evaluation with our cataract specialist will confirm whether surgery is the right next step for your vision and eye health.",
      },
      {
        header: " How Is Cataract Surgery Performed? ",
        content:
          "Our surgeons use phacoemulsification - a micro-incision technique that uses ultrasonic energy to gently break up and remove the clouded natural lens. The process is precise, blade-free, and leaves no stitches.Lens Removal During Cataract Surgery A tiny incision (less than 3mm) is made at the edge of the cornea. The cloudy lens is emulsified using ultrasonic waves and carefully removed through the same small opening. Laser Precision and Micro-Incision Technology Advanced optical biometry is used before surgery to map your eye and calculate the exact IOL power needed. This ensures accurate post-surgery vision and reduces dependence on glasses. Intraocular Lens (IOL) Implant OptionsA clear, foldable artificial lens is inserted through the same micro-incision and positioned precisely inside the eye. We offer a full range of IOL types:",
        points: [
          "  Monofocal IOL - sharp distance vision",
          " Toric IOL - corrects astigmatism alongside the cataract",
          "  Multifocal IOL - distance and near vision without glasses",
          "Trifocal IOL - distance, intermediate, and near vision (minimal glass dependence)",
          "Fading or yellowing of colours",
        ],
          content1:
          "Recovery After Cataract SurgeryMost patients experience improved clarity within 24 hours. Complete healing and final vision stabilisation typically occurs over 4–6 weeks. Post-operative care includes prescribed eye drops, a review within 24 hours, and follow-up appointments at one week and one month.",
      },
      {
        header: "What Is Robotic Cataract Surgery?",
        content:
          "Robotic cataract surgery also known as femtosecond laser-assisted cataract surgery (FLACS) - is the most advanced form of cataract treatment available today. At Amrit Hospitals, our robotic cataract programme combines computer-guided laser precision with the surgical expertise of our ophthalmology team, delivering outcomes that are measurably more accurate than conventional techniques alone.Unlike standard phacoemulsification, where every incision is made manually, robotic cataract surgery uses a femtosecond laser to pre-programme and execute the most critical steps of the procedure with sub-micron accuracy. The result is a highly controlled, blade-free operation with reduced ultrasonic energy, minimised risk, and faster visual recovery.",
        points: [
          "Lens Removal: The cloudy lens is carefully extracted.",
          "Laser Precision: Advanced laser technology ensures accurate surgery.",
          "Artificial Lens Implant: The natural lens is replaced with a clear, artificial lens.",
          "Quick Recovery: Performed under local anesthesia, allowing swift recovery and immediate vision improvement.",
        ],
      },
    ],

    faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1.  Why Choose Amrit Hospital for Cataract Treatment?",
        content:
          "Our ophthalmology team combines decades of surgical experience with advanced technology to deliver safe, precise cataract care. Every patient receives a personalised treatment plan focused on restoring clear, comfortable vision.",
      },
      {
        label: "2.. What Cataract Services Are Available at Amrit Hospital?",
        content:
          "We offer a full spectrum of cataract services from initial diagnosis and pre-operative evaluation to blade-free phacoemulsification surgery and structured post-operative follow-up. Treatment plans are tailored to each patient's eye health, lifestyle, and vision goals.",
      },
      {
        label: "3.  Is Cataract Surgery Safe at Amrit Hospital?",
        content:
          "Yes. Cataract surgery is one of the most widely performed and safest ophthalmic procedures in the world. Our surgeons follow stringent clinical protocols, and every patient undergoes a thorough pre-operative assessment including corneal biometry and IOL power calculation to ensure the best possible outcome.",
      },
      {
        label: "4. What Technology Is Used for Cataract Treatment?",
        content:
          "We use phacoemulsification with micro-incision technology for lens removal, combined with advanced optical biometry to precisely calculate the correct intraocular lens (IOL) power for each patient. This ensures accurate vision correction and a faster, stitch-free recovery.",
      },
      {
        label: "5. What Post-Surgery Care Is Provided After Cataract Treatment?",
        content:
          " Post-operative care includes prescribed eye drops, a follow-up visit within 24 hours, and review appointments at one week and one month. Our team provides detailed recovery guidelines on activities, diet, and what to watch for ensuring proper healing and long-term eye health.",
      },
      {
        label: "6. Does Amrit Hospital Treat Cataracts in Elderly Patients?",
        content:
          "Yes. Age-related cataracts are among the most common conditions we treat. Elderly patients receive special attention including anaesthesia suitability checks, slower-paced recovery planning, and family guidance - to ensure the process is as smooth and stress-free as possible.",
      },
      {
        label: "7. What is robotic cataract surgery and how is it different?",
        content:
          " Robotic cataract surgery or femtosecond laser-assisted cataract surgery (FLACS) uses a computer-guided laser to perform the most precise steps of the procedure: the corneal incisions, the capsule opening, and initial lens fragmentation. Unlike conventional surgery, where these steps are done manually, the laser executes them to a pre-programmed plan based on your exact eye measurements. The result is greater accuracy, reduced surgical energy, and an optimised outcome particularly for patients choosing premium IOLs.",
      },
      {
        label: "8. Is robotic cataract surgery available at Amrit Hospitals?",
        content:
          "Yes. Our ophthalmology department offers femtosecond laser-assisted cataract surgery as part of our advanced eye care programme. The procedure is performed by our experienced cataract surgeons using certified laser technology with real-time OCT imaging guidance. During your pre-operative consultation, our robotic cataract doctor will assess whether laser-assisted surgery offers a specific benefit for your case.",
      },
      {
        label: "9.  Is robotic cataract surgery safe for elderly patients?",
        content:
          "Yes, and it is often particularly well-suited for older patients with dense cataracts or fragile corneal tissue. Because the laser reduces the amount of ultrasonic energy required during lens removal, it minimises stress on delicate eye structures which can be especially beneficial in age-related cases. As with all procedures at our hospital, elderly patients receive individualised pre-operative assessment and tailored anaesthesia planning.",
      },
      {
        label: "10.  Appointments can be booked easily through the hospital's online system or by contacting the hospital directly. The team will assist in scheduling a consultation with an eye specialist.",
        content:
          "Booking is quick and easy. Use the 'Book an Appointment' button on this page, call our front desk directly, or fill in the contact form. A member of our cataract team will confirm your consultation slot and answer any questions before your visit.",
      },
    ],
  },
  },
  {
    id: "glaucoma",
    label: "Glaucoma",
    img: gulcoma,
    banner: glaucomaI,
     title: "Glaucoma Specialists in Chennai – Eye Pressure Management",
    description: "Get expert glaucoma diagnosis and treatment in Chennai at Amrit Hospitals. Prevent vision loss with early detection and modern care. Book now.",
    keyword: "",
    data: [
      {
        header: "What is Glaucoma?",
        content:
          "Glaucoma is a group of eye conditions that damage the optic nerve, typically due to increased pressure inside the eye, leading to gradual vision loss if untreated.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Gradual Loss of Peripheral Vision",
          "Blurred Vision",
          "Halos around Lights",
          "Severe Eye Pain",
        ],
      },
      {
        header: "Possible Treatments",
        content:
          "Glaucoma can be managed and prevented by the following possible ways:",
        points: [
          "Medication: Prescription eye drops or oral medications to reduce intraocular pressure.",
          "Laser Therapy: Procedures like laser trabeculoplasty to improve fluid drainage.",
          "Surgical Options: Trabeculectomy or minimally invasive glaucoma surgery (MIGS) to create new drainage channels.",
        ],
      },
    ],
    faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1.  Why Choose Amrit Hospital for Glaucoma Care?",
        content:
          " Amrit Hospital provides comprehensive glaucoma management with experienced ophthalmologists and advanced diagnostic support. Our focus is on early detection and long-term eye health preservation.",
      },
      {
        label: "2.  What Glaucoma Services Are Available at Amrit Hospital?",
        content:
          " Services include glaucoma screening, medical management, surgical care, and regular monitoring. Treatment plans are tailored based on the stage and severity of the condition.",
      },
      {
        label: "3. How Is Glaucoma Diagnosed at Amrit Hospital?",
        content:
          " Advanced diagnostic tools are used to measure eye pressure, assess optic nerve health, and monitor vision changes. This helps in accurate diagnosis and timely care.",
      },
      {
        label: "4.  Is Glaucoma Treatment Safe at Amrit Hospital?",
        content:
          " All glaucoma treatments follow established clinical protocols with patient safety as a priority. Our specialists ensure careful monitoring during every stage of care.",
      },
      {
        label: "5.  Does Amrit Hospital Provide Long-Term Glaucoma Management?",
        content:
          " Yes, long-term monitoring and follow-up care are an important part of glaucoma management. This helps in controlling progression and maintaining vision.",
      },
      {
        label: "6. Are Surgical Options Available for Glaucoma Treatment?",
        content:
          " Surgical treatment options are available when required and are recommended after thorough evaluation. Procedures are performed using modern techniques and equipment.",
      },
      {
        label: "7. How Can I Book an Appointment for Glaucoma Consultation?",
        content:
          " Appointments can be scheduled through the hospital’s online booking system or by contacting the hospital directly for assistance.",
      },
    ],
  },
  },
  {
    id: "corneaAndKeratoconus",
    label: "Cornea Specialist & Keratoconus Treatment in Chennai",
    img: cornea,
    banner: corneaI,
     title: "Cornea Specialist & Keratoconus Cure Chennai | Amrit Hospitals",
    description: "Visit Amrit Hospitals — expert cornea specialist & keratoconus specialist in Chennai. Advanced cross-linking, Intacs & corneal transplant. Book today.",
    keyword: "",
    faqSchema: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "What does a cornea specialist treat?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "A cornea specialist is an ophthalmologist trained to diagnose and treat conditions affecting the cornea, including keratoconus, corneal infections, corneal scarring, dry eye disease, corneal ulcers, and corneal dystrophies. They also perform advanced corneal surgeries and corneal transplants.",
          },
        },
        {
          "@type": "Question",
          name: "What is the best treatment for keratoconus?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "The best treatment depends on the stage of keratoconus. Early cases are often managed with Corneal Collagen Cross-Linking (CXL) to stop progression, while moderate cases may benefit from Intacs corneal ring implants. Advanced keratoconus may require corneal transplant surgery.",
          },
        },
        {
          "@type": "Question",
          name: "How do I know if I have keratoconus?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Common symptoms of keratoconus include blurred or distorted vision, frequent changes in spectacle prescription, glare, halos around lights, and difficulty with night vision. A detailed corneal topography examination can help confirm the diagnosis.",
          },
        },
        {
          "@type": "Question",
          name: "Is keratoconus curable?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Keratoconus cannot be completely reversed, but its progression can often be stopped with Corneal Cross-Linking when detected early. Many patients achieve stable vision with appropriate treatment and long-term monitoring.",
          },
        },
        {
          "@type": "Question",
          name: "What corneal treatments are available at Amrit Hospitals?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Our cornea specialists provide Corneal Collagen Cross-Linking (CXL), Intacs corneal ring implantation, corneal transplant surgery, DALK procedures, PTK treatment, and comprehensive management for keratoconus and other corneal disorders.",
          },
        },
        {
          "@type": "Question",
          name: "What post-treatment care is provided after corneal surgery?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Post-treatment care includes scheduled follow-up visits, corneal topography monitoring, prescription eye drops, vision rehabilitation guidance, and ongoing evaluation to support optimal healing and long-term visual outcomes.",
          },
        },
        {
          "@type": "Question",
          name: "When should I see a cornea specialist?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You should consult a cornea specialist if you experience persistent blurred vision, eye pain, corneal infections, progressive changes in vision, keratoconus symptoms, or if you have been diagnosed with a corneal disorder.",
          },
        },
        {
          "@type": "Question",
          name: "Can keratoconus cause vision loss?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "If left untreated, keratoconus can progressively distort the cornea and significantly affect vision quality. Early diagnosis and treatment can help preserve vision and reduce the risk of severe visual impairment.",
          },
        },
        {
          "@type": "Question",
          name: "Are corneal transplants successful?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Corneal transplant procedures generally have high success rates when performed for appropriate indications. Modern surgical techniques and careful follow-up help achieve good visual outcomes for many patients.",
          },
        },
        {
          "@type": "Question",
          name: "How can I book a consultation with a keratoconus specialist in Chennai?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "You can schedule an appointment with our cornea and keratoconus specialists by contacting Amrit Hospitals, using the online appointment form, or speaking directly with our patient care team.",
          },
        },
      ],
    },
    data: [
      {
        header: "What is Cornea & Keratoconus Care?",
        content:
          "Cornea and Keratoconus Care focuses on specialized treatments for conditions affecting the cornea, such as keratoconus, aimed at improving corneal health and enhancing visual outcomes through advanced therapies and surgical interventions.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Blurry or Distorted Vision",
          "Increased Sensitivity to Light",
          "Difficulty with Night Vision",
          "Frequent Changes in Eyeglass Prescription",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our treatments include:",
        points: [
          "Cross-Linking: Strengthening the cornea with UV light and riboflavin drops.",
          "Intacs: Implantation of small plastic rings to reshape the cornea.",
          "Corneal Transplant: Replacement of the damaged cornea with a healthy donor cornea, tailored to your specific needs.",
        ],
      },
    ],
   faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. What does a cornea specialist treat?",
      content:
        "A cornea specialist is an ophthalmologist with advanced fellowship training in conditions affecting the cornea - the transparent front surface of the eye. At Amrit Hospitals, our cornea specialists treat keratoconus, corneal infections (keratitis), corneal scarring, dry eye disease, bullous keratopathy, Fuchs' endothelial dystrophy, and perform corneal transplants. If you have been told your cornea is affected in any way, a dedicated cornea eye specialist is the right doctor to see.",
    },
    {
      label: "2. What is the best treatment for keratoconus in Chennai?",
      content:
        "The best treatment depends on the stage of keratoconus. In early to moderate stages, Corneal Collagen Cross-Linking (CXL) is the most effective way to halt progression. In moderate cases with poor contact lens tolerance, Intacs corneal ring implants can improve vision. For advanced keratoconus with significant scarring, corneal transplantation (DALK or PKP) is recommended. At Amrit Hospitals - one of Chennai's best hospitals for keratoconus treatment - our specialists will assess your cornea and recommend the most appropriate treatment pathway.",
    },
    {
      label: "3. How do I know if I have keratoconus?",
      content:
        "Keratoconus often presents as blurry or distorted vision, frequent changes in spectacle prescription, glare and halos around lights, and difficulty with night vision. However, early keratoconus can be completely asymptomatic and is only detectable through corneal topography. If you have any of these symptoms or a family history of keratoconus, visit our keratoconus specialist in Chennai for a detailed corneal evaluation.",
    },
    {
      label: "4. Is keratoconus curable?",
      content:
        "Keratoconus cannot be reversed, but its progression can be effectively halted with Corneal Cross-Linking especially when performed in the early stages. Many patients achieve stable, good-quality vision for decades after cross-linking with the help of contact lenses or Intacs. In advanced cases, corneal transplantation offers excellent visual outcomes. The key is early detection and timely treatment by an experienced keratoconus specialist.",
    },
    {
      label: "5. What corneal surgeries are available at Amrit Hospitals?",
      content:
                 "Amrit Hospitals performs: Corneal Collagen Cross-Linking (CXL) for keratoconus stabilisation, Intacs corneal ring segment implantation,  DALK (Deep Anterior Lamellar Keratoplasty) for advanced keratoconus,  Penetrating Keratoplasty (full-thickness corneal transplant) for scarred or failed corneas, and PTK (Phototherapeutic Keratectomy) for corneal surface diseases. All procedures are performed by our fellowship-trained cornea eye specialists.",
    },
    {
      label: "6. What Post-Treatment Care Is Provided?",
      content:
        "Following any corneal procedure at Amrit Hospitals, patients receive a comprehensive follow-up programme including scheduled review visits, corneal topography monitoring to track outcomes, prescription eye drop regimens, vision rehabilitation guidance, and 24-hour emergency contact access for any post-operative concerns. Our team monitors recovery carefully to ensure the best possible visual outcome.",
    },
    {
      label: "7. How Can I Book a Cornea Consultation?",
      content:
        "Booking is easy. Call +91 9600 711818, WhatsApp +91 76959 57120, or use the online appointment form on our website. We offer consultations at our Sowcarpet (362, Mint Street, Chennai 600079) and Purasaiwakkam (73/28 Dr Alagappa Road, Chennai 600084) centres. Same-day or next-day appointments are usually available for urgent corneal concerns.",
    },
  ],
}, 
  },
  {
    id: "pediatricOphthalmology",
    label: "Pediatric Ophthalmology",
    img: pedia,
    banner: pediaI,
     title: "Pediatric Eye Specialist in Chennai – Trusted Child Eye Care",
    description: "Ensure your child’s eye health with top pediatric ophthalmologists in Chennai at Amrit Hospitals. Book expert vision care for kids today.",
    keyword: "",
    data: [
      {
        header: "What is Pediatric Ophthalmology?",
        content:
          "Pediatric Ophthalmology involves specialized eye care tailored specifically for children, addressing a wide range of vision issues from infancy through adolescence. This field focuses on early detection, diagnosis, and treatment of conditions that can affect visual development, ensuring optimal eye health and function as children grow.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Frequent Squinting or Blinking",
          "Difficulty Reading or Seeing Objects up Close",
          "Poor Hand-Eye Coordination",
          "Inability to Maintain Eye Contact",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our pediatric ophthalmologists provide:",
        points: [
          "Glasses or Contacts: Correcting refractive errors such as nearsightedness or astigmatism.",
          "Vision Therapy: Exercises and activities to improve eye muscle strength and coordination.",
          "Surgical Intervention: Procedures to correct strabismus (crossed eyes) or congenital cataracts, ensuring comprehensive care for young patients.",
        ],
      },
    ],
faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Pediatric Eye Care?",
      content:
        "Our pediatric ophthalmology team provides child-friendly eye care using modern technology and experienced specialists. Safety and comfort are prioritized.",
    },
    {
      label: "2. What Pediatric Eye Services Are Offered?",
      content:
        "We provide vision screening, diagnosis, treatment, and ongoing follow-up for children’s eye conditions.",
    },
    {
      label: "3. Is Pediatric Eye Care Safe at Amrit Hospital?",
      content:
        "Yes, all procedures follow child-specific safety protocols and are conducted by trained pediatric eye specialists.",
    },
    {
      label: "4. Are Vision Problems in Children Treated Here?",
      content:
        "Yes, a wide range of pediatric vision issues, including refractive errors and eye disorders, are managed with tailored care plans.",
    },
    {
      label: "5. Are Child-Friendly Facilities Available?",
      content:
        "Our environment is designed to be comfortable and reassuring for children and their families during consultations and treatments.",
    },
    {
      label: "6. Is Long-Term Pediatric Eye Monitoring Provided?",
      content:
        "Yes, ongoing follow-up ensures early detection of vision changes and continued eye health.",
    },
    {
      label: "7. How Can Parents Book an Appointment?",
      content:
        "Appointments can be booked online or by contacting the hospital directly for consultation with a pediatric ophthalmologist.",
    },
  ],
},
  },
  {
    id: "retina",
    label: "Retina",
    img: retina,
    banner: retinaI,
     title: "Retina Treatment in Chennai – Expert Eye Specialists",
    description: "Receive specialized retina care in Chennai at Amrit Hospitals. Diagnosis and treatment for retinal detachment, diabetic retinopathy & more.",
    keyword: "",
    data: [
      {
        header: "What is Retina Ophthalmology?",
        content:
          "Retina care involves the diagnosis, treatment, and management of various conditions affecting the retina, a critical layer of tissue at the back of the eye responsible for converting light into neural signals for vision. This specialized field addresses a range of retinal disorders, such as macular degeneration, diabetic retinopathy, retinal detachment, and more.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Floaters or Spots in Vision",
          "Flashes of Light",
          "Sudden Loss of Vision",
          "Distorted or Wavy Vision",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our retina specialists offer:",
        points: [
          "Intravitreal Injections: Medications injected directly into the eye to treat retinal conditions.",
          "Laser Therapy: Procedures to seal or repair retinal tears or blood vessels.",
          "Vitrectomy: Surgical removal of the vitreous gel to treat severe retinal conditions and ensure comprehensive retinal care.",
        ],
      },
    ],
    faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Retina Care?",
      content:
        "Amrit Hospital offers specialized retina care using advanced imaging and treatment techniques performed by experienced ophthalmologists.",
    },
    {
      label: "2. What Retina Services Are Available?",
      content:
        "Services include diagnosis, medical management, and surgical treatment for retinal diseases and conditions.",
    },
    {
      label: "3. How Are Retina Conditions Diagnosed?",
      content:
        "Modern imaging systems are used to assess retinal health and guide precise treatment plans.",
    },
    {
      label: "4. Is Retina Treatment Safe at Amrit Hospital?",
      content:
        "All treatments follow strict clinical protocols to ensure safety and effectiveness for every patient.",
    },
    {
      label: "5. Does Amrit Hospital Provide Long-Term Retina Care?",
      content:
        "Yes, regular monitoring and follow-up care are provided to maintain eye health and prevent complications.",
    },
    {
      label: "6. Are Advanced Treatments Available for Retinal Disorders?",
      content:
        "Yes, the hospital offers modern medical and surgical solutions tailored to individual patient needs.",
    },
    {
      label: "7. How Can I Book a Retina Consultation?",
      content:
        "Appointments can be scheduled online or by contacting the hospital directly for a retina specialist consultation.",
    },
  ],
},
  },
  {
    id: "oculoplastyAndCosmeticEnhancement",
    label: "Oculoplasty and Cosmetic Enhancement",
    img: oculo,
    banner: oculoI,
     title: "Oculoplasty & Cosmetic Eye Surgery in Chennai",
    description: "Get expert oculoplasty and cosmetic enhancement procedures at Amrit Hospitals. Treat eyelid issues, eye tumors & more. Book consultation now.",
    keyword: "",
    data: [
      {
        header: "What is Oculoplasty and Cosmetic Enhancement?",
        content:
          "Oculoplasty and Cosmetic Enhancement involve surgical procedures focused on the eyelids, tear ducts, and orbit (bony socket around the eye), as well as non-surgical treatments to improve the appearance and function of the eyes and surrounding structures.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Drooping Eyelids",
          "Excessive Tearing",
          "Puffiness or Bags under Eyes",
          "Wrinkles or Fine Lines around Eyes",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our oculoplasty and cosmetic enhancement services include:",
        points: [
          "Blepharoplasty: Surgery to remove excess skin or fat from the eyelids.",
          "Botox Injections: Non-surgical treatment to reduce wrinkles and fine lines.",
          "Tear Duct Surgery: Procedures to clear blocked tear ducts, ensuring both functional and aesthetic improvements.",
        ],
      },
    ],
    faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Oculoplasty Services?",
      content:
        "Amrit Hospital provides specialized oculoplasty procedures for both functional and cosmetic eye care, handled by experienced surgeons.",
    },
    {
      label: "2. What Oculoplasty Services Are Offered?",
      content:
        "Services include eyelid surgeries, tear duct procedures, and cosmetic eye enhancements tailored to patient needs.",
    },
    {
      label: "3. Is Oculoplasty Treatment Safe?",
      content:
        "All procedures follow strict safety protocols and are performed by skilled ophthalmic surgeons.",
    },
    {
      label: "4. Are Cosmetic Eye Enhancements Available?",
      content:
        "Yes, aesthetic procedures are offered with care to ensure natural outcomes and patient satisfaction.",
    },
    {
      label: "5. What Pre-Procedure Evaluation Is Conducted?",
      content:
        "Comprehensive assessments are carried out to plan procedures safely and effectively.",
    },
    {
      label: "6. What Post-Treatment Care Is Provided?",
      content:
        "Follow-up care includes recovery monitoring and guidance to ensure optimal results.",
    },
    {
      label: "7. How Can I Schedule an Oculoplasty Consultation?",
      content:
        "Appointments can be booked online or by contacting the hospital directly.",
    },
  ],
},
  },
  {
    id: "contactLenses",
    label: "Contact Lenses",
    img: contace,
    banner: contactLensesI,
     title: "Get Contact Lenses in Chennai – Personalized Eye Fit",
    description: "Explore a wide range of contact lenses at Amrit Hospitals, Chennai. Perfect fit, advanced testing & vision correction. Schedule an eye test today.",
    keyword: "",
    data: [
      {
        header: "What is Contact Lens Care?",
        content:
          "Contact Lens Care involves the fitting, prescription, and maintenance of contact lenses to correct various vision problems such as nearsightedness, farsightedness, astigmatism, and presbyopia. It encompasses a range of lens types and wearing schedules tailored to individual needs.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Discomfort or Irritation",
          "Redness or Swelling",
          "Blurred Vision",
          "Dry Eyes",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our contact lens care services include:",
        points: [
          "Custom Fittings: Personalized fittings for optimal comfort and vision.",
          "Specialty Lenses: Options like multifocal, toric, or rigid gas permeable lenses.",
          "Ongoing Care: Regular check-ups to monitor eye health and lens performance, ensuring comprehensive contact lens management.",
        ],
      },
    ],
      faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Contact Lens Services?",
      content:
        "Amrit Hospital offers professional contact lens fitting and eye assessments by experienced specialists to ensure comfort and safety.",
    },
    {
      label: "2. What Contact Lens Services Are Available?",
      content:
        "Services include evaluation, fitting, prescription guidance, and lens care instructions.",
    },
    {
      label: "3. Is Professional Fitting Important for Contact Lenses?",
      content:
        "Yes, proper fitting ensures optimal comfort, safety, and long-term eye health.",
    },
    {
      label: "4. Are Follow-Up Services Provided After Fitting?",
      content:
        "Yes, patients receive follow-up support to monitor eye health and lens comfort.",
    },
    {
      label: "5. Are Specialized Contact Lenses Available?",
      content:
        "Specialized lenses, including corrective and therapeutic types, are provided as needed.",
    },
    {
      label: "6. How Does the Hospital Ensure Eye Safety?",
      content:
        "All fittings follow strict clinical hygiene protocols, and patients are guided on safe usage.",
    },
    {
      label: "7. How Can I Book a Contact Lens Appointment?",
      content:
        "Appointments can be scheduled online or through direct hospital contact.",
    },
  ],
},
  },
  {
    id: "neuroOphthalmology",
    label: "Neuro Ophthalmology",
    img: neuro,
    banner: neuroI,
     title: "Neuro-Ophthalmology Experts in Chennai – Eye & Brain Care",
    description: "Consult leading neuro-ophthalmologists in Chennai at Amrit Hospitals. Specialized care for optic nerve disorders & visual pathway issues.",
    keyword: "",
    data: [
      {
        header: "What is Neuro Ophthalmology?",
        content:
          "Neuro Ophthalmology focuses on the complex relationship between the eyes and the brain, diagnosing and managing visual problems related to the nervous system, including optic nerve disorders, visual field loss, and neurological diseases affecting vision.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Sudden Vision Loss",
          "Double Vision",
          "Visual Field Loss",
          "Eye Movement Disorders",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our neuro ophthalmologists provide:",
        points: [
          "Comprehensive Evaluation: Detailed assessments to identify the underlying neurological causes of visual symptoms.",
          "Medical Management: Treatments for conditions like optic neuritis, myasthenia gravis, and pseudotumor cerebri.",
          "Surgical Interventions: Procedures to address issues such as optic nerve compression or eye movement abnormalities, ensuring integrated care for complex visual disorders.",
        ],
      },
    ],
    faqsSection: {
  heading: "FAQs Section",
  services: [
    {
      label: "1. Why Choose Amrit Hospital for Neuro-Ophthalmology Care?",
      content:
        "Amrit Hospital provides specialized care for complex vision and neurological conditions, handled by experienced ophthalmologists and neurologists.",
    },
    {
      label: "2. What Neuro-Ophthalmology Services Are Available?",
      content:
        "Services include evaluation, diagnosis, and management of vision issues linked to neurological disorders.",
    },
    {
      label: "3. Is Advanced Diagnostic Support Available?",
      content:
        "Yes, modern diagnostic tools are used to accurately assess and monitor neurological eye conditions.",
    },
    {
      label: "4. Does Amrit Hospital Offer Multidisciplinary Care?",
      content:
        "Care is coordinated with other specialists, ensuring comprehensive management of complex conditions.",
    },
    {
      label: "5. Is Patient Safety Prioritized?",
      content:
        "Strict clinical protocols and expert supervision ensure safe and effective care.",
    },
    {
      label: "6. Are Long-Term Monitoring Services Provided?",
      content:
        "Yes, patients receive ongoing follow-up and care plans tailored to their condition.",
    },
    {
      label: "7. How Can I Book a Neuro-Ophthalmology Appointment?",
      content:
        "Appointments can be booked online or by contacting the hospital directly to consult with a neuro-ophthalmology specialist.",
    },
  ],
},
  },
  {
    id: "lowVisionSyndrome",
    label: "Low Vision Syndrome",
    img: lowvision,
    banner: lowvisionI,
     title: "Low Vision Syndrome Treatment in Chennai – Improve Your Vision",
    description: "Regain visual function with low vision rehabilitation in Chennai at Amrit Hospitals. Personalized aids and therapy for vision enhancement.",
    keyword: "",
    data: [
      {
        header: "What is Low Vision Syndrome?",
        content:
          "Low Vision Syndrome involves significant visual impairment that cannot be fully corrected with glasses, contact lenses, or surgery, often resulting from conditions such as macular degeneration, glaucoma, diabetic retinopathy, or congenital disorders. This condition affects daily functioning and quality of life.",
        points: null,
      },
      {
        header: "Symptoms to Lookout for",
        content:
          "If you come across the following symptoms, consult your doctor immediately to ensure timely diagnosis and appropriate treatment.",
        points: [
          "Difficulty Recognizing Faces",
          "Trouble Reading or Seeing Details",
          "Loss of Central or Peripheral Vision",
          "Struggling with Bright or Low Light Conditions",
        ],
      },
      {
        header: "Possible Treatments",
        content: "Our low vision services include:",
        points: [
          "Vision Rehabilitation: Training and tools to maximize remaining vision.",
          "Assistive Devices: Magnifiers, special glasses, and electronic aids.",
          "Adaptive Techniques: Strategies to enhance daily living skills and independence, ensuring comprehensive support for low vision individuals.",
        ],
      },
    ],

    faqsSection: {
    heading: "FAQs Section",
    services: [
      {
        label: "1. Why Choose Amrit Hospital for Low Vision Care?",
        content:
          " Amrit Hospital provides supportive care for patients with reduced vision, helping them maintain independence and quality of life.",
      },
      {
        label: "2. What Low Vision Services Are Available?",
        content:
          " Services include assessment, visual aids, and personalized care plans for patients with low vision.",
      },
      {
        label: "3. How Is Low Vision Evaluated?",
        content:
          " Advanced diagnostic tools are used to assess vision loss and identify suitable support options.",
      },
      {
        label: "4. Are Assistive Solutions Provided?",
        content:
          " Yes, patients are offered customized visual aids and strategies to enhance daily functioni",
      },
      {
        label: "5.  Is Long-Term Support Available?",
        content:
          " Ongoing care and monitoring are provided to ensure continuous visual assistance.",
      },
      {
        label: "6. Does the Hospital Treat All Age Groups?",
        content:
          " Low vision care is available for children, adults, and the elderly with tailored solutions.",
      },
      {
        label: "7. How Can I Schedule a Low Vision Consultation?",
        content:
          "Appointments can be booked online or by contacting the hospital directly for personalized evaluation.",
      },
    ],
  },

  },
  
];

export const list = [
  {
    id: "smileProSurgery",
    label: "Smile Pro Surgery",
    content: "datamap",
  },
  {
    id: "contouraVision",
    label: "Contoura Vision - Specs Removal",
    content: "datamap",
  },
  {
    id: "cataract",
    label: "Cataract",
    content: "datamap",
  },
  {
    id: "glaucoma",
    label: "Glaucoma",
    content: "datamap",
  },
  {
    id: "corneaAndKeratoconus",
    label: "Cornea and Keratoconus",
    content: "datamap",
  },
  {
    id: "pediatricOphthalmology",
    label: "Pediatric Ophthalmology",
    content: "datamap",
  },
  {
    id: "retina",
    label: "Retina",
    content: "datamap",
  },
  {
    id: "oculoplastyAndCosmeticEnhancement",
    label: "Oculoplasty and Cosmetic Enhancement",
    content: "datamap",
  },
  {
    id: "contactLenses",
    label: "Contact Lenses",
    content: "datamap",
  },
  {
    id: "neuroOphthalmology",
    label: "Neuro Ophthalmology",
    content: "datamap",
  },
  {
    id: "lowVisionSyndrome",
    label: "Low Vision Syndrome",
    content: "datamap",
  },
];

export const listheader = "Our Eye Care specialties";

export const opthomologyInternal = { list, internalData, listheader };
